import script from "./AddressDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AddressDialog.vue?vue&type=style&index=0&id=6e193434&lang=scss"
import "./AddressDialog.vue?vue&type=style&index=1&id=6e193434&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e193434"]])

export default __exports__